import React from "react";

export const Slider_text = () => {
    return (
        <div className="slider_text">
            <h1 className="slider_text_h1">Fortissimoは、無料のITエンジニア育成サイトです。</h1>
            <p className="slider_text_p">まずは会員登録を行ってから、学習システムにログインする事で学習をスタートできます。</p>
        </div>
    )
}